import { useEffect, useRef } from "react";
import { useGame } from "../data/gameContext";
import bugBustInstance from "../debugger/bugBustLog";
import { gameConfig } from "../game/gameConfig";

export default function useTravelMovement() {
  const { gameState, updateGameState } = useGame(); 
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  bugBustInstance.add("useTravelMovement.ts: useTravelMovement() called");
  useEffect(() => {
    const { TravelTimeLeft, Location, TravelTo } = gameState.PlayerCharacter ?? {};
    if (!gameState.PlayerCharacter || TravelTimeLeft === undefined || !Location || !TravelTo || TravelTimeLeft <= 0)
      return;

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }


      // Calculate remaining distances
      const distanceX = TravelTo.x - Location.x;
      const distanceY = TravelTo.y - Location.y;

      // Determine step sizes
      const stepSizeX = distanceX / TravelTimeLeft;
      const stepSizeY = distanceY / TravelTimeLeft;

      // New position calculation
      const newX = Location.x + stepSizeX;
      const newY = Location.y + stepSizeY;

      if ((Math.round(newX) === TravelTo.x && Math.round(newY) === TravelTo.y) || TravelTimeLeft === 1) {
        clearInterval(intervalRef.current!);
        intervalRef.current = null;
        updateGameState({
          PlayerCharacter: {
            ...gameState.PlayerCharacter!,
            Location: {...TravelTo},
            TravelTimeLeft: 0,
          },
          Phase: "mapView",
          LastEncounter: 0 //always reset the last encounter when you get to a town.
        });
        return;
      } else {    
        // do a random encounter check here with a 50% chance to be true per 10 hours (ish)
        const encounter = Math.random() < gameConfig.RandomEncounter && (gameState.GameTime + 1) > (gameState.LastEncounter + gameConfig.MinEncounterInterval) ; //don't get constant encounters just cos of bad rolls, have a minimum gap.
        
        // Update game state with new position and decrement travel time
        updateGameState({
          PlayerCharacter: {
            ...gameState.PlayerCharacter!,
            Location: {
            x: newX,
            y: newY},
            TravelTimeLeft: encounter ? TravelTimeLeft : TravelTimeLeft - 1,
          },
          GameTime: gameState.GameTime + 1, //should when switching to encounter? We aren't decrementing the travel time. Surely we shoudl change both or neither?
          Phase: encounter ? "encounter" : "travelling",
          Horse: {
            ...gameState.Horse,
            Stamina: gameState.Horse.Stamina - 1,
            Water: gameState.Horse.Water - 1,
          },
          LastEncounter: encounter && gameState.Phase === "travelling" ? gameState.GameTime + 1 : gameState.LastEncounter //we haven't updated game time yet.
        });
      }
  

  }, [gameState.PlayerCharacter?.TravelTimeLeft]);
}
